import {Injectable} from "@angular/core";
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Observable} from "rxjs"
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ToastService} from "../toast/toast.service";
import {ValidateDataComponent} from '../../../components/restore-password/validate-data.component';
import {environment} from "../../../../environments/environment";

@Injectable({providedIn: "root"})
export class RestorePasswordService {
    private modalRef: NgbModalRef;
    private baseEndpoint: string;
    private body: any;

    open() {
        this.configModal();
    }

    constructor(
        private modalService: NgbModal,
        private http: HttpClient,
        private modalConfig: NgbModalConfig,
        private toastService: ToastService,
    ) {
        this.baseEndpoint = environment.apiUser
        modalConfig.backdrop = 'static';
        modalConfig.keyboard = true;
    }

    configModal() {
        this.modalRef = this.modalService.open(ValidateDataComponent);
    }

    close() {

        this.modalRef.close();

    }

    validateData(nameOwner: string, numAcount: string, email: string, nameUser: string): Observable<any> {
        this.body = {
            nomTitular: nameOwner,
            numContrato: numAcount,
            correo: email,
            nomUsuario: nameUser
        }
        return this.http.post<any>(`${this.baseEndpoint}/password/validate/data`, this.body)
    }

    resendToken(temporalJwt: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization-Reset-Pass', temporalJwt);
        const url = `${this.baseEndpoint}/password/token/resend`;
        return this.http.get<any>(url, {headers})
    }

    validateOtpResetPassword(temporalJwt: string, code: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization-Reset-Pass', temporalJwt);
        const url = `${this.baseEndpoint}/password/code/validation`;
        return this.http.post<any>(url, {otp: code}, {headers})
    }
}
